<template>
  <div class="register">
    <nav-bar
      fixed
      z-index="99"
      title="登录"
      left-text="返回"
      left-arrow
      @click-left="$router.go(-1)"
    />
    <div style="height: 46px"></div>
    <div style="display: flex; justify-content: center; padding: 30% 0">
      <img
        style="width: 4rem; height: 3.1rem"
        src="@/assets/img/login_logo.png"
        alt="蒲公英家庭教练中心"
      />
    </div>
    <form class="register-form" @submit.prevent="submit">
      <div>
        <!-- <div class="register-form-name"><span>*</span>手机号</div>
        <div class="register-form-input acea-row row-between-wrapper">
          <input class="w-f" placeholder="请输入手机号" v-model="username" />
        </div>
        <div class="register-form-name"><span>*</span>验证码</div>
        <div class="register-form-input acea-row row-between-wrapper">
          <input style="width: 3rem;" placeholder="请输入验证码" v-model="captcha" />
          <div class="text-num" @click="code">{{ text }}</div>
        </div> -->
        <div style="font-size: 0.23rem; margin-top: 0.6rem; color: #999999">
          <Checkbox shape="square" v-model="agree" checked-color="#0ce6df">
            我已阅读并同意
            <router-link :to="'/view_detail/41'" style="color: #0ce6df"
              >《用户协议》</router-link
            >
            和
            <router-link :to="'/view_detail/49'" style="color: #0ce6df"
              >《隐私政策》</router-link
            >
          </Checkbox>
        </div>
        <!-- <div class="btn" style="margin-top: 0.4rem" @click="submit">
          登录账号
        </div> -->
      </div>
      <div
        class="btn"
        style="margin-top: 0.43rem"
        v-if="isWeixin"
        @click="weixinLogin"
      >
        <img
          style="width: 0.4rem; vertical-align: middle; margin-right: 0.2rem"
          src="@assets/img/weixin.png"
        />微信一键登录
      </div>
      <div class="clear-cache" @click="clearCache">
        登录有问题？点击清除缓存
      </div>
    </form>
  </div>
</template>
<script>
import sendVerifyCode from "@mixins/SendVerifyCode";
import { login, registerVerify } from "@api/user";
import attrs, { required, alpha_num, chs_phone } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
import dayjs from "dayjs";
import cookie from "@utils/store/cookie";
import { Checkbox, NavBar } from "vant";
import { isWeixin } from "@utils/index";
import { getConfig, toAuth } from "@libs/wechat-handle";

const BACK_URL = "login_back_url";

export default {
  name: "Login",
  components: { Checkbox, NavBar },
  mixins: [sendVerifyCode],
  data: function () {
    return {
      username: "",
      password: "",
      captcha: "",
      formItem: 1,
      type: "login",
      agree: false,
      isWeixin: isWeixin(),
    };
  },
  created() {
    if (this.$route.query && this.$route.query.errorTip) {
      this.username = cookie.get("username");
      this.captcha = cookie.get("captcha");
      cookie.remove("username");
      cookie.remove("captcha");
      this.agree = true;
      this.$dialog.error(decodeURIComponent(this.$route.query.errorTip));
    }
    // const fullPath = this.$route.query.redirect;
    // if (fullPath) {
    //   cookie.set(BACK_URL, fullPath);
    // }
  },
  mounted() {
    // 判断是否登录，如果登录了就跳转到首页
    if (this.$store.state.app.token) {
      this.$router.replace({ path: "/" });
    }
  },
  methods: {
    // weixinLogin() {
    //   // 如果跳转过来有redirect参数，就把这个参数存到cookie里面，用于在App主页做跳转
    //   const fullPath = this.$route.query.redirect;
    //   if (fullPath) {
    //     cookie.set(BACK_URL, fullPath);
    //   }
    //   if (!this.agree) {
    //     this.$dialog.toast({ mes: "请勾选阅读并同意用户协议" });
    //     return;
    //   }
    //   const module = () => import("@libs/wechat");
    //   module().then((Module) => {
    //     Module.default().then(() => Module.oAuth());
    //   });
    // },
    async weixinLogin() {
      try {
        const fullPath = this.$route.query.redirect;
        // 登录前清理所有缓存
        this.clearCache(false);
        this.$log.wechat("开始微信登录流程");
        this.$log.wechat("当前重定向地址:", fullPath);
        this.$log.wechat("获取未登录时的token", cookie.get("login_status"));
        if (!this.agree) {
          this.$log.warn("用户未同意协议");
          this.$dialog.toast({ mes: "请勾选阅读并同意用户协议" });
          return;
        }
        this.$log.wechat("开始获取微信配置:getConfig");
        const config = await getConfig();
        this.$log.wechat("获取到的微信配置:", JSON.stringify(config));

        if (fullPath) {
          this.$log.wechat("开始保存回调地址:cookie.set");
          cookie.set("login_back_url", fullPath);
          this.$log.debug("已保存回调地址:", fullPath);
        }
        this.$log.wechat("开始微信授权:toAuth");
        toAuth(config.appId, fullPath);
      } catch (e) {
        this.$log.error("weixinLogin微信登录失败:", e);
        this.$dialog.error(e.msg || "微信登录失败，请稍后重试");
      }
    },
    async code() {
      var that = this;
      const { username } = that;
      try {
        await that
          .$validator({
            username: [
              required(required.message("手机号码")),
              chs_phone(chs_phone.message()),
            ],
          })
          .validate({ username });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      await registerVerify({ phone: that.username, type: "login" })
        .then((res) => {
          that.$dialog.success(res.msg);
          that.sendCode();
        })
        .catch((res) => {
          that.$dialog.error(res.msg);
        });
    },
    async submit() {
      if (!this.agree) {
        this.$dialog.toast({ mes: "请勾选阅读并同意用户协议" });
        return;
      }
      const { username, captcha } = this;
      try {
        await this.$validator({
          username: [
            required(required.message("账号")),
            attrs.range([5, 16], attrs.range.message("账号")),
            alpha_num(alpha_num.message("账号")),
          ],
          captcha: [
            required(required.message("验证码")),
            attrs.range([6, 16], attrs.range.message("验证码")),
            alpha_num(alpha_num.message("验证码")),
          ],
        }).validate({ username, captcha });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      cookie.set("username", username);
      cookie.set("captcha", captcha);
      const module = () => import("@libs/wechat");
      if (this.isWeixin) {
        module().then((Module) => {
          Module.default().then(() => Module.toBaseLogin());
        });
      } else {
        login({
          username,
          captcha,
          userCategory: 1,
          spread: cookie.get("spread"),
        })
          .then(({ data }) => {
            this.$store.commit("LOGIN", data.token, dayjs(data.expires_time));
            this.$store.commit("SET_USER", data);

            const redirectTo = this.$route.query.redirect;
            if (redirectTo) {
              this.$router.push(redirectTo);
            } else {
              this.$router.replace({ path: "/" });
            }
          })
          .catch((e) => {
            this.$dialog.error(e.msg);
          });
      }
    },
    clearCache(toast = true) {
      cookie.clearAll();
      localStorage.clear();
      sessionStorage.clear();
      if (toast) {
        this.$log.info("清除缓存");
        this.$dialog.toast({
          mes: "缓存已清除",
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.register {
  padding: 0.77rem 0.64rem;
  height: 100vh;
  background: #ffffff;
  position: relative;

  .register-title {
    font-size: 0.42rem;
    font-weight: 700;
  }

  .register-title-text {
    color: #999999;
    margin-top: 0.19rem;
  }

  .register-form {
    margin-top: 0.23rem;
  }

  .register-form-name {
    margin-bottom: 0.19rem;
    margin-top: 0.44rem;
  }

  .register-form-input {
    height: 0.78rem;
    padding: 0 0.23rem;
    background-color: #f8f8f8;
    border-radius: 2rem;
  }

  .text-num {
    color: #b9bde5;
  }

  .btn {
    display: block;
    color: #fff;
    width: 100%;
    height: 0.68rem;
    background: #0ce6df;
    line-height: 0.68rem;
    text-align: center;
    border-radius: 0.5rem;
  }

  .bottom {
    margin-top: 0.3rem;
    color: #999999;
  }

  .clear-cache {
    text-align: center;
    font-size: 0.24rem;
    color: #999999;
    margin-top: 0.3rem;
    padding: 0.1rem;
  }
}
</style>
